<template>
  <layout>
    <rdkm-title>
      {{ $t('Настройки') }}
    </rdkm-title>
    <div class="tile">      
      <rdkm-grid :state="query">
        <grid-column name="EDIT" cell="edit-cell"></grid-column>
        <grid-column name="description" :title="$t('Описание')"></grid-column>
        <grid-column name="value" :title="$t('Значение')" :format="function(val, row) { return row.settingType == 4 ? '****' : val }"></grid-column>
      </rdkm-grid>
    </div>
  </layout>
</template>

<script>
import Grid from "../../components/grid/Grid.vue";
import GridColumn from "../../components/grid/GridColumn.vue";

export default {
  name: "Settings",
  props: ["query"],
  components: {
    "rdkm-grid": Grid,
    "grid-column": GridColumn
  }
};
</script>
